import { render } from "./RemovePromotion.vue?vue&type=template&id=1fc23513"
import script from "./RemovePromotion.vue?vue&type=script&lang=js"
export * from "./RemovePromotion.vue?vue&type=script&lang=js"

import "./RemovePromotion.vue?vue&type=style&index=0&id=1fc23513&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__